import { Box, Divider, Grow, ListItem, ListItemText } from "@material-ui/core";
import { forwardRef, useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useMapThemeClasses } from "../../hooks/use-map-theme-styles";
import layoutStyles from "./layout-styles";

export type BaseModule = { name: string; link: string; key: string; icon?: JSX.Element };

export interface IModulesProps {
	modules?: Array<{
		main: BaseModule;
		subModules: Array<BaseModule>;
	}>;
	handleDrawerClose?: () => void;
}

const Modules: React.FC<IModulesProps> = ({ modules }) => {
	const { pathname } = useLocation();
	const { modulesRoot, bgPrim, bgWhite } = layoutStyles();
	const { selectedItem, navBarBold, navBarHover } = useMapThemeClasses();
	const moduleNa = modules && modules.find((m) => m.main.link.toLowerCase() === pathname.split("/")[1])?.main.key;
	const moduleNu = moduleNa ? +moduleNa : -1;
	const [module, setModule] = useState(0);

	function getLink(i: string | undefined) {
		return modules && "/" + modules.find((e) => e.main.key === i)?.main.link.toLowerCase();
	}

	useEffect(() => {
		setModule(moduleNu);
		return () => setModule(0);
	}, [pathname, modules]);

	return (
		<Box aria-labelledby="modules" className={modulesRoot}>
			{modules?.map((m, i) => {
				const isSelected = isNaN(module) || module === +m.main.key;
				const ForwardNavLink = forwardRef((props, ref) => (
					<NavLink {...props} innerRef={ref as any} to={getLink(m.main.key)} key={i} id={`${m.main.name.toLowerCase()}Module`} />
				));
				return (
					<Box key={i}>
						<ListItem button component={ForwardNavLink} className={selectedItem}>
							<ListItemText
								primary={m.main.name}
								primaryTypographyProps={{
									classes: { root: `${isSelected ? navBarBold : navBarHover}` },
								}}
							/>
						</ListItem>
						<Grow timeout={350} in={isSelected}>
							<Divider classes={{ root: isSelected ? bgPrim : bgWhite }} />
						</Grow>
					</Box>
				);
			})}
		</Box>
	);
};

export default Modules;
